// Importaciones de react
import { AuthContext } from 'context';
import { useContext, useState } from 'react';

export const useInitalValues = () => {
  const { sucursalNoAdministrada } = useContext(AuthContext);
  const sucursalContext = sucursalNoAdministrada.sucursales; //TODO: VERIFICAR
  const [residuoReceptor, setResiduoReceptor] = useState({
    rol: {
      codigoRol: 2
    },
    empresa: null, // Seleccionar la empresa de origen para usuarios que tengan permisos de administración de sucursales
    // Seleccionar la sucursal de origen
    sucursal: sucursalContext || null, // codigoSucursal registrado en la base de datos (Integer)
    direccion: sucursalContext ? sucursalContext.direccion : {},
    nombreDireccionSucursal: sucursalContext
      ? `${sucursalContext.direccion.nombreVia}, ${sucursalContext.direccion.comuna?.nombreComuna}, Región ${sucursalContext.direccion.comuna?.region?.nombreRegion} `
      : '',
    nombreSucursal: '',

    // Tipo de Residuo
    tipoResiduo: [],
    // SubTipo de Residuo
    subTipoResiduo: [],
    tieneSubTipoResiduo: false,

    //Nombre Residuo
    nombreResiduo: '',

    // Tipo de Recursos
    tipoRecurso: [],
    tieneTipoRecursos: false,

    // Otro Tipo de Recursos
    otroTipoRecurso: [],
    tieneOtroTipoRecurso: false,

    // Tipo de Recurso de Reemplazo
    recursoReemplazo: [],
    tieneTipoRecursosReemplazo: false,
    // Sub Tipo de Recurso de Reemplazo
    subTipoRecursoReemplazo: {},

    // Descripción adicional
    descripcionAdicional: ''
  });

  const [residuoGenerador, setResiduoGenerador] = useState({
    // PASO 1

    rol: {
      codigoRol: 1
    },

    // Nombre LER
    nombreLER: [],

    // Nombre Sub Tipo LER
    nombreSubLER: [],

    // Nombre Sub Sub Tipo LER
    nombreSubSubLER: [],

    // nombreResiduo: '',

    // Tipo de Residuo
    tipoResiduo: [],

    // SubTipo de Residuo
    subTipoResiduo: [],

    tieneSubTipoResiduo: false,
    tieneTipoRecursos: false,
    tieneOtroTipoRecurso: false,

    // Otro Tipo de Residuo
    otroSubtipoResiduo: '',
    tieneOtroSubtipoResiduo: false,

    // Tipo de Recursos
    tipoRecurso: [],

    // Otro Tipo de Recursos
    otroTipoRecurso: [],

    // Descipción adicional
    descripcionAdicional: '',

    // PASO 2
    // Seleccionar la empresa de destino para usuarios que tengan permisos de administración de sucursales
    empresa: null,
    // TODO: controlar que se llenan los campos de la sucursal cuando solo tenga una
    sucursal: sucursalContext || null, // codigoSucursal registrado en la base de datos (Integer)
    direccion: sucursalContext ? sucursalContext.direccion : {},
    nombreDireccionSucursal: sucursalContext
      ? `${sucursalContext.direccion.nombreVia}, ${sucursalContext.direccion.comuna?.nombreComuna}, Región ${sucursalContext.direccion.comuna?.region?.nombreRegion} `
      : '',
    nombreSucursal: '',
    precioReferencial: '',
    frecuencia: '',
    fechaDisponibilidad: new Date(),
    formatoEntrega: '',
    cantidad: 0,
    unidadMedida: null,

    // Paso 3
    imagenes: [],
    archivosResiduos: []
  });

  return {
    residuoReceptor,
    setResiduoReceptor,
    residuoGenerador,
    setResiduoGenerador
  };
};
